"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenAuth = listenAuth;
const component_1 = require("../component");
const events_1 = require("@front/event/events");
const component_2 = require("@front/components/site-menu/component");
function listenAuth() {
    this.on('force-register', (event) => {
        this.loaded = false;
        this.togglePreloader();
        this.getBody().classList.remove('loaded');
        this.forceRegister = event.detail.register;
    });
    this.on('force-remind', (event) => {
        this.loaded = false;
        this.togglePreloader();
        this.getBody().classList.remove('loaded');
        this.resetPasswordMode = event.detail.remind;
    });
    this.on('force-login', (event) => {
        this.loaded = false;
        this.togglePreloader();
        this.getBody().classList.remove('loaded');
        this.forceRegister = false;
        component_2.SiteMenu.goto.bind(this)('/login');
    });
    this.on(events_1.appEvents.login, (event) => {
        const user = this.storage().getUser();
        if (user && user.id) {
            this.isLogged = true;
            component_1.DefaultLayout.USER = user;
        }
    });
    this.on(events_1.appEvents.logout, (event) => {
        component_1.DefaultLayout.USER = null;
        this.storage().clearUser();
        this.clearAuth();
        this.isLogged = false;
        this.getBody().classList.add('background');
        this.getBody().classList.add('no-footer');
        this.getBody().classList.remove('right-menu');
    });
    window.addEventListener(events_1.appEvents.authExpired, () => {
        if (this.isLogged) {
            this.$emit(events_1.appEvents.logout);
            component_2.SiteMenu.goto.bind(this)('/login');
        }
    });
}
